import { render, staticRenderFns } from "./MainLoyout.vue?vue&type=template&id=2c0a6f1f&scoped=true"
import script from "./MainLoyout.vue?vue&type=script&lang=js"
export * from "./MainLoyout.vue?vue&type=script&lang=js"
import style0 from "./MainLoyout.vue?vue&type=style&index=0&id=2c0a6f1f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a6f1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0a6f1f')) {
      api.createRecord('2c0a6f1f', component.options)
    } else {
      api.reload('2c0a6f1f', component.options)
    }
    module.hot.accept("./MainLoyout.vue?vue&type=template&id=2c0a6f1f&scoped=true", function () {
      api.rerender('2c0a6f1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/loyout/MainLoyout.vue"
export default component.exports